if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        const formData = new FormData(this.form);
        const subscriptionWidget = document.querySelector('subscription-widget');

        // Prefer purchase-widget quantity / selling plan when present
        if (subscriptionWidget) {
          const qtyInput = subscriptionWidget.querySelector('#widget_quantity');
          const planInput = subscriptionWidget.querySelector('#widget_selling_plan');
          if (qtyInput?.value) formData.set('quantity', qtyInput.value);
          if (planInput && !planInput.disabled && planInput.value) {
            formData.set('selling_plan', planInput.value);
          } else {
            formData.delete('selling_plan');
          }
        }

        const sellingPlan = formData.get('selling_plan');
        let giftVariantIds = [];

        if (sellingPlan && subscriptionWidget && typeof subscriptionWidget.getGiftVariantIds === 'function') {
          giftVariantIds = subscriptionWidget.getGiftVariantIds();
        }

        giftVariantIds = await this.filterGiftVariantIdsNotInCart(giftVariantIds);

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        if (giftVariantIds.length) {
          config.body = JSON.stringify(this.buildSubscriptionGiftPayload(formData, giftVariantIds, sellingPlan));
        } else {
          delete config.headers['Content-Type'];
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('.product-form__submit-label')?.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              if (typeof window.syncCartThresholdGift === 'function') {
                await window.syncCartThresholdGift();
              }
              window.location = window.routes.cart_url;
              return;
            }

            if (typeof window.syncCartThresholdGift === 'function') {
              const synced = await window.syncCartThresholdGift();
              if (synced?.cart?.sections) {
                response.sections = Object.assign({}, response.sections, synced.cart.sections);
              }
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      async filterGiftVariantIdsNotInCart(candidateIds) {
        if (!candidateIds.length) return [];

        try {
          const cart = await fetch('/cart.js').then((res) => res.json());
          const cartVariantIds = new Set((cart.items || []).map((item) => Number(item.variant_id)));
          return candidateIds.filter((id) => !cartVariantIds.has(Number(id)));
        } catch (error) {
          console.error(error);
          return candidateIds;
        }
      }

      buildSubscriptionGiftPayload(formData, giftVariantIds, sellingPlan) {
        const quantity = Number(formData.get('quantity') || 1);
        const bundleId = `sub-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        const parentItem = {
          id: Number(formData.get('id')),
          quantity,
          properties: {
            _subscription_bundle: bundleId,
          },
        };

        if (sellingPlan) parentItem.selling_plan = Number(sellingPlan);

        const items = [parentItem];

        giftVariantIds.forEach((giftVariantId) => {
          items.push({
            id: Number(giftVariantId),
            quantity: 1,
            properties: {
              _subscription_bundle: bundleId,
              _subscription_gift: 'true',
            },
          });
        });

        const payload = { items };

        if (this.cart) {
          payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        return payload;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
